import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/solid'
import { Avatar, Card, CardBody, CardHeader, Carousel, IconButton, Typography } from '@material-tailwind/react'
import React from 'react'

const TestiCard = (AvaImg) => (
	<>
		<Card color="transparent" shadow={true} className="w-full max-w-[26rem] p-3">
      <CardHeader
        color="transparent"
        floated={false}
        shadow={false}
        className="mx-0 flex items-center gap-4 pb-8 m-auto"
      >
        <Avatar
					className='!static'
          size="lg"
          variant="circular"
          src= {AvaImg}
          alt="tania andrew"
        />
        <div className="flex w-full flex-col gap-0.5">
          <div className="flex items-center justify-between">
            <Typography variant="h5" color="blue-gray">
              Tania Andrew
            </Typography>
          </div>
          <Typography color="blue-gray">Frontend Lead @ Google</Typography>
        </div>
      </CardHeader>
      <CardBody className="mb-3 p-0 text-center">
        <Typography>
          &quot;I found solution to all my design needs from Creative Tim. I use
          them as a freelancer in my hobby projects for fun! And its really
          affordable, very humble guys !!!&quot;
        </Typography>
      </CardBody>
    </Card>
	</>
)

function Testimoni() {

  return (
    <div className='mb-16 px-7 md:px-11 static'>
    <Typography variant='h4' className='pb-5 text-center underline underline-offset-8'>Bagaimana mereka dapat kerja</Typography>
    <Typography variant='small' className='pb-5 text-center'>Simak cerita tentang cara mendapat pekerkaan via RealJob.</Typography>

    <div className='hidden md:grid md:grid-cols-3 gap-4 content-center justify-center'>
			{TestiCard('testi1.png')}
			{TestiCard('testi2.png')}
			{TestiCard('testi3.png')}
    </div>

    <div className='md:hidden pb-5' >
      <Carousel 
        loop={true} 
        nextArrow={({handleNext}) => (<IconButton onClick={handleNext} variant="text" color="gray" size="lg" className="!absolute top-2/4 left-1 -translate-y-2/4"><ChevronLeftIcon className="w-6 text-gray-200 dark:text-gray-200"/></IconButton>)} 
        prevArrow={({handlePrev}) => (<IconButton onClick={handlePrev} variant="text" color="gray" size="lg" className="!absolute top-2/4 !right-1 -translate-y-2/4"><ChevronRightIcon className="w-6 text-gray-200 dark:text-gray-200"/></IconButton>)}
        navigation={({ setActiveIndex, activeIndex, length }) => (
          <div className="absolute bottom-0 left-2/4 z-50 flex -translate-x-2/4 gap-2">
            {new Array(length).fill("").map((_, i) => (
              <span
                key={i}
                className={`block h-1 cursor-pointer rounded-2xl transition-all content-[''] ${
                  activeIndex === i ? "w-8 bg-gray-900" : "w-4 bg-gray-300"
                }`}
                onClick={() => setActiveIndex(i)}
              />
            ))}
          </div>
        )}
      
      >
        <div className='grid justify-evenly'>{TestiCard('testi3.png')}</div>
        <div className='grid justify-evenly'>{TestiCard('testi2.png')}</div>
        <div className='grid justify-evenly'>{TestiCard('testi1.png')}</div>
      </Carousel>
    </div>

    </div>
  )
}

export default Testimoni